import React from "react";
import { motion } from "framer-motion";
import Button from "./components/Button";
import CardContent from "./components/CardContent";
import Card from "./components/Card";
import { Linkedin, Mail } from "lucide-react";

export default function GraceKatzPersonalWebsite() {
  return (
    <div className="min-h-screen w-full bg-gray-100 flex flex-col">
      {/* Hero Section */}
      <div className="relative flex items-center justify-center h-64 bg-cover bg-center bg-[url('https://images.unsplash.com/photo-1530549387789-16ef09f5fbb0?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDF8fGVkaXRpb24lMjBvcGVuJTIwYm9vayUyMGJhY2tncm91bmR8ZW58MHx8fHwxNjc4MDM3NzY2&ixlib=rb-4.0.3&q=80&w=1080')]">
        <div className="absolute inset-0 bg-black/40" />
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-white text-4xl md:text-6xl font-bold relative z-10"
        >
          Grace Katz
        </motion.h1>
      </div>

      {/* About Section */}
      <div className="flex-1 p-4 md:p-8">
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto"
        >
          <h2 className="text-2xl md:text-3xl font-bold mb-4">About Me</h2>
          <p className="mb-2">
            Hi! I'm Grace Katz, a junior marketing student at James Madison University.
            I'll graduate in 2026. I love combining creativity and data insights to
            develop effective marketing strategies.
          </p>
          <p className="mb-2">
            I've completed an internship and also held a part-time job, both of which
            shaped my passion for strategic problem solving. I'm also actively involved
            with the <b>REDACTED</b> Club at JMU, honing my analytical and presentation skills.
          </p>
        </motion.div>

        {/* Education & Experience */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mt-8"
        >
          <Card className="shadow-lg rounded-2xl">
            <CardContent>
              <h3 className="text-xl font-semibold mb-2">Education</h3>
              <p className="mb-1">James Madison University (2026)</p>
              <p className="text-sm text-gray-600">Bachelor of Business Administration in Marketing</p>
            </CardContent>
          </Card>
          <Card className="shadow-lg rounded-2xl">
            <CardContent>
              <h3 className="text-xl font-semibold mb-2">Experience</h3>
              <ul className="list-disc ml-5 space-y-1">
                <li>Marketing Intern at XYZ Company</li>
                <li>Part-time Role at ABC Retail</li>
                <li>Member of the <b>REDACTED</b> Club @ JMU</li>
              </ul>
            </CardContent>
          </Card>
        </motion.div>

        {/* Contact Section */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto mt-12"
        >
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Get in Touch</h2>
          <div className="flex flex-col md:flex-row gap-4">
            <Button className="shadow-lg rounded-2xl flex gap-2 items-center">
              <Mail className="w-5 h-5" />
              <span>Email Me</span>
            </Button>
            <Button className="shadow-lg rounded-2xl flex gap-2 items-center">
              <Linkedin className="w-5 h-5" />
              <span>LinkedIn</span>
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t py-4">
        <p className="text-center text-sm text-gray-600">© {new Date().getFullYear()} Grace Katz</p>
      </footer>
    </div>
  );
}
